import { Box, Typography } from "@mui/material";
import Button, { ButtonProps as MuiButtonProps } from "@mui/material/Button";
import React from "react";

interface SimpleSidebarButtonProps extends Omit<MuiButtonProps, 'onClick'> {
  link: string;
  label: string;
  currentPath: string;
  onClick: () => void;
  children: React.ReactNode;
}

export const SidebarButton: React.FC<SimpleSidebarButtonProps> = ({
  children,
  link,
  label,
  currentPath,
  onClick,
  ...rest
}) => {
  const isActive = currentPath.includes(link);
  const color = isActive ? "#FF006F" : "#2e2d2d";
  const background = "#FF409F";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "10px",
      }}
    >
      <Button
        onClick={onClick}
        sx={{
          bgcolor: color,
          "&:hover": {
            backgroundColor: background,
          },
          borderRadius: "999px",
          paddingX: 0,
          minWidth: "auto",
          width: "40px",
          height: "40px",
        }}
        {...rest}
      >
        {children}
      </Button>
      <Typography
        sx={{
          color: "white",
          fontSize: 13,
          textAlign: "center",
          mt: 0.5,
          lineHeight: 1.2,
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};
